export const PAYOUTS = [
  2700000, 1620000, 1020000, 600000, 540000, 502500, 465000, 435000, 405000,
  375000, 345000, 315000, 285000, 270000, 255000, 240000, 225000, 210000,
  195000, 180000, 168000, 156000, 144000, 132000, 120000, 115500, 111000, 106500,
  102000, 97500, 93000, 88500, 84750, 81000, 77250, 73500, 70500, 67500, 64500,
  61500, 58500, 55500, 52500, 49500, 46500, 43500, 41100, 39000, 37800, 36900,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
  10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
];
